/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Folder_Created_SuccessInputs */



/**
* | output |
* | --- |
* | "Folder created successfully!" |
*
* @param {Spaces_Folder_Created_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_folder_created_success = /** @type {((inputs?: Spaces_Folder_Created_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Folder_Created_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner erfolgreich erstellt!")
	return /** @type {LocalizedString} */ ("Folder created successfully!")
});